// @flow

const GET_PLANS_URL = '/api/plans?coupon=:coupon';
const GET_AGENCY_PLANS_URL = '/api/agency_plans';
export const PLANS_UPDATING = 'plans/UPDATING';
export const PLANS_UPDATED = 'plans/UPDATED';
export const AGENCY_PLANS_UPDATED = 'agency_plans/UPDATED';

export const getPlansByCoupon = ({ coupon }: { coupon: string }) => {
  return (dispatch: Function) => {
    dispatch({ type: PLANS_UPDATING });
    fetch(GET_PLANS_URL.replace(':coupon', `${coupon}`), {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache'
      },
      credentials: 'include'
    })
      .then((response) => {
        return response.json().then((data) => {
          return { data, status: response.status };
        });
      })
      .then(({ data, status }) => {
        dispatch({
          type: PLANS_UPDATED,
          data
        });
      });
  };
};
export const getAgencyPlans = () => {
  return (dispatch: Function) => {
    dispatch({ type: PLANS_UPDATING });
    fetch(GET_AGENCY_PLANS_URL, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache'
      },
      credentials: 'include'
    })
      .then((response) => {
        return response.json().then((data) => {
          return { data, status: response.status };
        });
      })
      .then(({ data, status }) => {
        dispatch({
          type: AGENCY_PLANS_UPDATED,
          data
        });
      });
  };
};

export default {
  getPlansByCoupon,
  getAgencyPlans
};



// WEBPACK FOOTER //
// ./src/actions/plans.actions.js